module.exports = __webpack_public_path__ + "img/place-order@2x.a8f1a243.png";